/* eslint-disable no-shadow */
/* eslint-disable */
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Add } from '@mui/icons-material';
// import { Button } from '@mui/material';
import Button from 'rsuite/Button';
import Accordion from 'rsuite/Accordion';
import Input from 'rsuite/Input';
import styles from './AllVendorsListPage.module.scss';
import { AddNewVendorModal } from '../../Components/Modals/AddNewVendorModal';
import AddressPanel from './AddressPanel';
import { formActions, modalActions } from '../../Actions';
import { AlertModal } from '../../Components/Modals';
import excel from '../../Images/excel.svg';
import allVendorServices from '@/Services/Form Services/allvendor.services';
import { handleResponseStreamDownload } from '@/Helpers';
import { useAuth } from '@/Components/Auth/Login/auth';
import { notificationServices } from '@/Services';
import authActions from '@/Actions/auth.actions';
import { BackdropLoader } from '@/Components/Loaders';
import { EyeIcon, Plus } from 'lucide-react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { urls } from '@/Constants';

const AllVendorListPage = (props) => {
	const {
		fetchVendors,
		data,
		buyersData,
		deleteVendor,
		toggleAlert,
		toggleAddVendorModal,
		type,
		navState,
		fetchUserList,
		userList,
	} = props;
	const { appConfig, userConfig } = useAuth();
	const [activeVendor, setActiveVendor] = useState(null);
	const [searchQuery, setSearchQuery] = useState('');
	const [loading, setLoading] = useState(false);
	const {level} = userConfig?.userDetails || {};
	const history = useHistory();
	const { userRolesDict } = userConfig;
	const isA2bCustomer = appConfig?.customerId === 68;
	const isInternal = Object?.values?.(userRolesDict ?? {}).some(role => role.toLowerCase().includes('internal'));
	const {
		masterCreation = true,
	} = appConfig?.configs ?? {};
	const masterDisallowedCreation=!((!isInternal && masterCreation)||(isInternal))



	const handleDelete = ({ vendor }) => {
		toggleAlert(true, {
			heading: 'Delete Vendor',
			height: '10rem',
			handleConfirm: () => {
				deleteVendor({
					entity: 'ALL_VENDORS',
					req: {
						params: {
							id: vendor?.id,
						},
					},
					method: 'DELETE',
				});
				toggleAlert(false);
			},
			colorReverse: true,
			cancelText: 'Cancel',
			confirmText: 'Delete',
			message: `Are you sure want to Delete Vendor - ${vendor?.name}?`,
		});
	};

	const fetchVendorsData = () => {
		fetchVendors({
			entity: type === 'VENDOR' ? 'ALL_VENDORS' : 'ALL_BUYERS',
			req: {
				params: {
					id: '',
				},
			},
			type,
			method: 'LIST',
		});
	};

	useEffect(() => {
		fetchVendorsData();
	}, [type]);
	const handleEditClick = (vendor) => {
		// eslint-disable-next-line no-console
		toggleAddVendorModal(true, {
			heading: type === 'VENDOR' ? 'Edit Vendor' : 'Edit Buyer',
			vendorData: vendor,
			isEdit: true,
			type,
			masterDisallowedCreation,
		});
	};

	const vendorHeader = (vendor) => {
		return (
			<div className={styles.vendor_header}>
				<div className={styles.vendor_details}>
					<div className={styles.name_company}>
						<p className={styles.vendor_name}>{vendor?.name}</p>

						<p className={styles.vendor_name}>{' (ID: ' + vendor?.id + ')'}</p>
						{vendor?.companyName && (
							<p>
								Company:
								{vendor?.companyName}
							</p>
						)}
						{vendor?.isExpenseAllowed && (
							<p className={styles.expense_allowed}>
								Allowed For Expenses
							</p>
						)}
					</div>
					<div className={styles.details}>
						<div className={styles.field}>
							<label className=''>{type === 'VENDOR' ? 'Vendor Type:' : 'Buyer Type'}</label>
							<p>{vendor?.vendorType}</p>
						</div>
						<div className={styles.field}>
							<label className=''>{type === 'VENDOR' ? 'Vendor Sub Type:' : 'Buyer Sub Type:'}</label>
							<p>{vendor?.subType}</p>
						</div>
					</div>
					{type === 'BUYER' && vendor?.paymentTermCode && (
						<div className={styles.details}>
							<div className={styles.field}>
								<label className=''>Payment Term Code</label>
								<p>{vendor?.paymentTermCode}</p>
							</div>
						</div>
					)}
				</div>
				{type !== 'VENDOR' && level !== 1 && !isA2bCustomer && (
					<div className="flex items-center gap-3 mt-2 mb-2">
						<p className="text-gray-700 font-medium ml-2 text-[12px] text-nowrap">Map Items with Buyer’s System</p>
						{vendor?.productMappingExist ? (
							<Button
								appearance="subtle"
								className="!bg-[#e9eef3] !text-[#222] !font-semibold !rounded !px-3 !py-1 !text-[14px] !border !border-[#cfd8e3] !shadow-none flex items-center gap-1"
								style={{
									boxShadow: 'none',
									backgroundColor: '#e9eef3',
									color: '#222',
									fontWeight: 600,
									borderRadius: '6px',
									padding: '0.25rem 0.75rem',
									fontSize: '14px',
									border: '1px solid #cfd8e3',
								}}
								onClick={() => {
									history.push({
										pathname: `${urls.EXTENSION}${urls.BUYER_PRODUCT_MAPPING}`,
										search: `?id=${vendor?.id}&view=true`,
										state: {
											prevPath: history.location.pathname,
										},
									})
								}}
							>
								<EyeIcon className="mr-1" size={16} /> View Mapping
							</Button>
						) : (
							<Button
								appearance="primary"
								className="!bg-[#f7b500] !text-[#222] !font-semibold !rounded !px-3 !py-1 !text-[14px] !border !border-[#f7b500] !shadow-none flex items-center gap-1"
								style={{
									boxShadow: 'none',
									backgroundColor: '#f7b500',
									color: '#222',
									fontWeight: 600,
									borderRadius: '6px',
									padding: '0.25rem 0.75rem',
									fontSize: '14px',
									border: '1px solid #f7b500',
								}}
								onClick={() => {
									history.push({
										pathname: `${urls.EXTENSION}${urls.BUYER_PRODUCT_MAPPING}`,
										search: `?id=${vendor?.id}&add=true`,
										state: {
											prevPath: history.location.pathname,
										},
									})
								}}
							>
								<Plus className="mr-1" size={16} /> Add Mapping
							</Button>
						)}
					</div>
				)}
				{level !== 1 && (
				<div className={styles.btns_container}>
					<Button
						onClick={() => {
							handleEditClick(vendor);
						}}
						appearance='ghost'
					>
						Edit
					</Button>
					<Button
						onClick={() => {
							handleDelete({
								vendor,
							});
						}}
						appearance='ghost'
						color='red'
					>
						Delete
					</Button>
				</div>
				)}
			</div>
		);
	};

	const handleExport = async (list) => {
		try {
			setLoading(true);
			let response;
			const name = type === 'VENDOR' ? 'VENDOR' : 'BUYER';
			if (type === 'VENDOR') {
				response = await allVendorServices.exportVendors({
					req: {
						data: list,
					},
				});
			} else {
				response = await allVendorServices.exportBuyers({
					req: {
						data: list,
					},
				});
			}
			if (response.status === 200) {
				handleResponseStreamDownload(
					response,
					`${name}_${appConfig?.companyName
						?.split(' ')
						?.join('_')
						?.toUpperCase()}.csv`
				);
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message: 'Some error occurred',
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: error,
			});
		}finally{
			setLoading(false);
		}
	};

	return (
		<div className={styles.root}>
			<AddNewVendorModal fetchVendorsData={fetchVendorsData} pageType={type} />
			<BackdropLoader showProgress isLoading={loading} />
			<AlertModal />
			<div className={styles.header}>
				<div className={styles.header_search}>
					<p className={styles['header-title']}>
						{type === 'VENDOR' ? 'All Vendors' : 'All Buyers'}
					</p>
					<div className={styles.filters}>
						<Input
							value={searchQuery}
							onChange={(value) => {
								setSearchQuery(value);
							}}
							style={{
								width: 250,
								borderRadius: 25,
								border: '1px solid #000',
							}}
							placeholder={type === 'VENDOR' ? 'Search Vendor/Location Name' : 'Search Buyer/Location Name'}
						/>
					</div>
				</div>
				{level !== 1 && (
					<div className='relative'>
				<button
					onClick={() => {
						toggleAddVendorModal(true, {
							type,
						});
					}}
					type='button'
					className={`${styles['add-btn']} ${masterDisallowedCreation ? '!opacity-50 !bg-gray-300' : ''}`}
					disabled={masterDisallowedCreation}
				>
					<Add />
					{type === 'VENDOR' ? 'Add Vendor' : 'Add Buyer'}
					</button>
					{masterDisallowedCreation && (
						<div className='absolute z-10 -bottom-4 w-full flex items-center justify-center '>
							<p className='text-red-500 text-[10px] text-nowrap whitespace-nowrap'>Direct creation not allowed</p>
						</div>
					)}
				</div>
				)}
			</div>
			<div className='flex justify-end w-full p-2'>
				<div
					onClick={() => {
						// eslint-disable-next-line no-undef
						handleExport(type === 'VENDOR' ? data : buyersData);
					}}
					className={styles.downloadData}
				>
					<img src={excel} alt='excel' />
					EXPORT
				</div>
			</div>
			<Accordion
				activeKey={activeVendor}
				bordered
				onSelect={setActiveVendor}
			>
				{(type === 'VENDOR' ? data : buyersData)
					.filter((vendor) => {
						return (
							vendor?.name
								?.toLowerCase()
								?.indexOf(
									searchQuery?.trim()?.toLowerCase()
								) !== -1 ||
							vendor?.vendor_locations?.some((location) => {
								return (
									location?.name
										?.toLowerCase()
										?.indexOf(
											searchQuery?.trim()?.toLowerCase()
										) !== -1
								);
							})
						);
					})
					.map((vendor) => {
						return (
							<Accordion.Panel
								header={vendorHeader(vendor)}
								eventKey={vendor?.id}
							>
								<div className={styles.accordion_body}>
									<div className={styles.locations}>
										{vendor?.vendor_locations?.map(
											(ele) => {
												return (
													<div
														className={
															styles.location
														}
													>
														<div
															className={
																styles.location_header
															}
														>
															<p
																className={
																	styles.location_name
																}
															>
																{ele?.name}
															</p>
															<p
																className={
																	styles.location_name
																}
															>
																GSTIN:
																{' '}
																{ele?.gstin}
															</p>
														</div>
														<div
															className={
																styles.location_detatils
															}
														>
															<div
																className={
																	styles.field
																}
															>
																<label>
																	Location
																	Email:
																</label>
																<p>
																	{
																		ele?.vendorEmail
																	}
																</p>
															</div>
															<div
																className={
																	styles.field
																}
															>
																<label>
																	Location
																	Phone:
																</label>
																<p>
																	{
																		ele?.vendorPhone
																	}
																</p>
															</div>
														</div>
														<AddressPanel
															addressDetails={{
																addressType:
																	'Billing Address',
																address1:
																	ele?.billingAddress1,
																address2:
																	ele?.billingAddress2,
																city: ele?.billingAddressCity,
																state: ele?.billingAddressState,
																pincode:
																	ele?.billingAddressPinCode,
															}}
														/>
														<AddressPanel
															addressDetails={{
																addressType:
																	'Pickup Address',
																address1:
																	ele?.shippingAddress1,
																address2:
																	ele?.shippingAddress2,
																city: ele?.shippingAddressCity,
																state: ele?.shippingAddressState,
																pincode:
																	ele?.shippingAddressPinCode,
															}}
														/>
													</div>
												);
											}
										)}
									</div>
								</div>
							</Accordion.Panel>
						);
					})}
			</Accordion>
		</div>
	);
};

const mapStateToProps = (state) => {
	const data = state.form.ALL_VENDORS.data.LIST;
	const buyersData = state.form.ALL_BUYERS.data.LIST;
	const { navState, userPermissions } = state.navigation;
	const { userList } = state.auth;
	return {
		data,
		buyersData,
		navState,
		userPermissions,
		userList,
	};
};

const mapDispatchToProps = {
	fetchVendors: formActions.gateway,
	deleteVendor: formActions.gateway,
	toggleAddVendorModal: modalActions.toggleAddVendorModal,
	toggleAlert: modalActions.toggleAlert,
	fetchUserList: authActions.fetchUserList,
};

export default connect(mapStateToProps, mapDispatchToProps)(AllVendorListPage);
